class QhAtvExtraLinha {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.data = dados ? dados.data : null;
    this.diaSemana = dados ? dados.diaSemana : null;
    this.descricao = dados ? dados.descricao : null;
    this.qtdeHora = dados ? dados.qtdeHora : null;
  }
}
export default QhAtvExtraLinha;
